import { intToBuffer, toBuffer } from '@exodus/ethereumjs/util'
import assert from 'minimalistic-assert'

import { currency2buffer, isToken } from '../utils/index.js'

export default function createUnsignedTxFactory({ chainId }) {
  assert(typeof chainId === 'number', 'chainId is required')
  return ({
    asset,
    address,
    amount,
    nonce,
    txInput,
    gasLimit,
    gasPrice, // eip 1559: `maxFeePerGas`
    tipGasPrice, // eip 1559: `maxPriorityPerGas`
    fromAddress,
    eip1559Enabled,
  }) => {
    const baseAsset = asset.baseAsset
    assert(chainId, 'chainId is required')

    if (txInput) {
      txInput = toBuffer(txInput) // If txInput is already a Buffer, then it is passed through
    } else {
      txInput = Buffer.alloc(0)
    }

    const _isToken = isToken(asset)
    const to = _isToken ? asset.contract.address : address
    let value = currency2buffer(_isToken ? baseAsset.currency.ZERO : amount)

    // TODO: check: present on desktop missing on mobile. This insures we never have a buffer specifying 0.
    // In ETH, a buffer of zero length and a buffer specifying 0 imply different things
    if (value.equals(Buffer.from([0]))) value = Buffer.alloc(0)

    assert(fromAddress, 'createTx: fromAddress is requied')

    const txData = {
      nonce: nonce === 0 ? Buffer.alloc(0) : intToBuffer(nonce),
      gasPrice: currency2buffer(gasPrice),
      tipGasPrice: tipGasPrice ? currency2buffer(tipGasPrice) : undefined,
      gasLimit: intToBuffer(gasLimit),
      to,
      value,
      data: txInput,
      chainId,
    }

    const txMeta = {
      assetName: asset.name,
      fee: baseAsset.currency.baseUnit(gasPrice.toBaseNumber() * gasLimit),
      eip1559Enabled: !!eip1559Enabled,
      fromAddress,
    }

    return {
      txData,
      txMeta,
    }
  }
}
